var map = {
	"./avatar.webp": 18,
	"./crwn-clothing.webp": 69,
	"./curology-min.webp": 70,
	"./photon.webp": 71,
	"./twitter-clone.webp": 72,
	"./whatsapp-clone.webp": 73,
	"./yourspace-min.webp": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;